export default __webpack_public_path__ + "static/media/57444957828__79E8799D-3A55-477C-85F8-C125D8E4BC9C.5caeaac6.jpg";